import { useState, useEffect } from "react";
import { VectorMap } from "devextreme-react";
import {
  ControlBar,
  Export,
  Label,
  Layer,
  Legend,
  Source,
  Subtitle,
  Title,
  Tooltip,
} from "devextreme-react/vector-map";

import { geojson, markers } from "./data";
import axios from "axios";

export default function MdcinClincTestInfoService01VectorMapBubble({
  setSido,
}) {
  const [dataSource, setDataSource] = useState(null);
  const center = [127.6358, 36];
  const sizeGroups = [0, 20, 40, 60, 80];

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_BECCO_API_URL}/api/clinicTestOprtnInsttInfoService01/bySIDO`
      )
      .then((result) => {
        markers.features = result.data.map((data) => ({
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: data.coordinates,
          },
          properties: {
            text: data.text,
            value: data.value,
            tooltip: `<b>${data.text}</b>\n${data.value}`,
          },
        }));

        setDataSource(markers);
      });
  }, []);

  const customizeTooltip = (arg) => {
    if (arg.layer.type === "marker") {
      return { text: arg.attribute("tooltip") };
    }
  };

  const customizeText = (arg) => {
    return ["< 20", "20 to 40", "40 to 60", "> 60"][arg.index];
  };

  const customizeItems = (items) => {
    for (const i in items) {
      if (items[i].start == 60) {
        items[i].states.normal.fill = "#1db2f5";
      } else if (items[i].start == 40) {
        items[i].states.normal.fill = "#f5564a";
      } else if (items[i].start == 20) {
        items[i].states.normal.fill = "#c69053";
      } else if (items[i].start == 0) {
        items[i].states.normal.fill = "#97c95c";
      }
    }

    return items.reverse();
  };

  const customize = (elements) => {
    for (const i in elements) {
      const value = elements[i].attribute("value");

      if (value > 60) {
        elements[i].applySettings({
          color: "#1db2f5",
        });
      } else if (value >= 40 && value < 60) {
        elements[i].applySettings({
          color: "#f5564a",
        });
      } else if (value >= 20 && value < 40) {
        elements[i].applySettings({
          color: "#c69053",
        });
      } else if (value < 20) {
        elements[i].applySettings({
          color: "#97c95c",
        });
      }
    }
  };

  const onClick = (e) => {
    const clickedElement = e.target;

    if (clickedElement && clickedElement.layer.type == "marker") {
      setSido(clickedElement.attribute("text"));
    }
  };

  return (
    <VectorMap
      id="MdcinClincTestInfoService01VectorMapBubble"
      center={center}
      zoomFactor={50}
      wheelEnabled={false}
      zoomingEnabled={false}
      onClick={onClick}
      background={{ borderColor: "#fff" }}
    >
      <Title text="실시기관 수" horizontalAlignment="center" />
      <Layer dataSource={geojson} hoverEnabled={false} />
      <Layer
        dataSource={dataSource}
        name="bubbles"
        elementType="bubble"
        dataField="value"
        minSize={20}
        maxSize={40}
        sizeGroups={sizeGroups}
        opacity="0.8"
        customize={customize}
      >
        <Label enabled={false} />
      </Layer>
      <Tooltip enabled={true} customizeTooltip={customizeTooltip} />
      <Legend
        markerShape="circle"
        customizeItems={customizeItems}
        customizeText={customizeText}
      >
        <Source layer="bubbles" grouping="size" />
      </Legend>
      <ControlBar enabled={false} />
      <Export enabled={true} />
    </VectorMap>
  );
}
